import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/t/documents')({
  staticData: { breadcrumb: 'Documents', breadcrumbKey: 'K_BREADCRUMB_DOCUMENTS' },
  component: DocumentsLayout,
});

function DocumentsLayout() {
  return <Outlet />;
}
